/*
  Full-stack architecture, back-end & front-end development
  from scratch by Hosein Geramipour

  GitHub: https://github.com/hoseingerami1999
  Phone:  +98 939 421 9998
*/

/** امضای توسعه‌دهنده؛ هم در کنسول چاپ می‌شود هم روی window در دسترس است. */
export const DEVELOPER = Object.freeze({
  name: 'Hosein Geramipour',
  title: 'Full-stack Developer',
  architecture: 'back-end & front-end, from scratch',
  github: 'https://github.com/hoseingerami1999',
  phone: '+98 939 421 9998',
});

declare global {
  interface Window {
    __DEVELOPER__?: typeof DEVELOPER;
  }
}

const MONO = 'font-family:ui-monospace,SFMono-Regular,Menlo,Consolas,monospace';

const NAME_STYLE = `background:#0a0a0a;color:#fafafa;font-size:13px;font-weight:700;padding:9px 16px;border-radius:8px 0 0 8px;${MONO}`;
const TITLE_STYLE = `background:#f5c518;color:#0a0a0a;font-size:13px;font-weight:700;padding:9px 16px;border-radius:0 8px 8px 0;${MONO}`;
const LABEL_STYLE = `color:#8b8b8b;font-size:12px;${MONO}`;
const VALUE_STYLE = `color:#2f81f7;font-size:12px;font-weight:600;${MONO}`;

/**
 * چاپ امضا در کنسول پنل مدیریت. `console.log` عمداً مستقیم صدا زده می‌شود چون
 * قالب‌بندی %c فقط در همین حالت توسط دواتولز رندر می‌شود.
 */
export function printSignature(): void {
  if (typeof window === 'undefined' || typeof console === 'undefined') return;

  window.__DEVELOPER__ = DEVELOPER;

  try {
    console.log(`%c ${DEVELOPER.name} %c ${DEVELOPER.title} `, NAME_STYLE, TITLE_STYLE);
    console.log(`%cArchitecture  %c${DEVELOPER.architecture}`, LABEL_STYLE, VALUE_STYLE);
    console.log(`%cGitHub        %c${DEVELOPER.github}`, LABEL_STYLE, VALUE_STYLE);
    console.log(`%cPhone         %c${DEVELOPER.phone}`, LABEL_STYLE, VALUE_STYLE);
  } catch {
    // کنسول‌های محدود (وب‌ویو‌های قدیمی) از %c پشتیبانی نمی‌کنند؛ امضا نباید اپ را بشکند.
  }
}
